// extracted by mini-css-extract-plugin
module.exports = {"range":"_3WJB28_fhFE5KhBm9yhalR"};